import React from 'react';
import './App.css';
import SortingVisualizer from './SortingVisualizer/SortingVisualizer';

const App = () => {
  return (
    <SortingVisualizer></SortingVisualizer>
  );
}

export default App;
